import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AppLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    const res = await fetch("https://fastapi-backend-789068808649.us-central1.run.app/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({ username, password }),
    });
    const data = await res.json();

    if (res.ok) {
      localStorage.setItem("app_token", data.access_token);

      // Give React Router and PrivateRoute time to see the new token
      setTimeout(() => {
        navigate("/");
      }, 50);
    } else {
      setError("Incorrect username or password");
    }
  };


  return (
    <div style={{
      display: 'flex',
      height: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f7f7f7',
      fontFamily: 'Inter, sans-serif'
    }}>
      <div style={{
        background: '#fff',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        minWidth: '350px',
        textAlign: 'center'
      }}>
        <h2 style={{ marginBottom: '24px', fontSize: '20px' }}>Login to Access Power Audit</h2>
        <input placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} style={inputStyle} />
        <input placeholder="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} style={inputStyle} />
        <button onClick={handleLogin} style={buttonStyle}>Login</button>
        {error && <p style={errorStyle}>{error}</p>}
      </div>
    </div>
  );
}

const inputStyle = {
  display: 'block',
  width: '100%',
  padding: '12px',
  marginBottom: '20px',
  fontSize: '16px',
  border: '1px solid #ccc',
  borderRadius: '6px'
};

const buttonStyle = {
  width: '100%',
  padding: '14px',
  backgroundColor: '#02AD24',
  color: 'white',
  border: 'none',
  fontSize: '16px',
  fontWeight: 'bold',
  borderRadius: '6px',
  cursor: 'pointer'
};

const errorStyle = {
  color: 'red',
  marginTop: '16px',
  textAlign: 'center',
  fontWeight: 'bold'
};
